import { render, staticRenderFns } from "./ModalPresupuestos.vue?vue&type=template&id=0808bf4f&scoped=true"
import script from "./ModalPresupuestos.vue?vue&type=script&lang=js"
export * from "./ModalPresupuestos.vue?vue&type=script&lang=js"
import style0 from "./ModalPresupuestos.vue?vue&type=style&index=0&id=0808bf4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0808bf4f",
  null
  
)

export default component.exports